<!-- 助力领券受邀页 -->
<template>
  <div class="homeContainer" v-if="dataReady" :style="bgColorStyle">
    <!-- 顶部导航按钮 -->
    <PinnedBtnContainer>
      <component
        v-for="pinnedBtnObj in pinnedBtnComponentObjs"
        :key="pinnedBtnObj.id"
        :is="pinnedBtnObj.component"
        v-bind="pinnedBtnObj.props"
        @reportEvent="handleReport"
      ></component>
    </PinnedBtnContainer>
    <!-- 模板头图 -->
    <Banner :imgUrl="tplData.pageConfig.headImage" />
    <Main
      :bgImgUrl="tplData.pageConfig.backgroundImage"
      :bgColor="tplData.pageConfig.backgroundColor"
    >
      <!-- 流式布局组件 -->
      <FlowComponentContainer
        v-for="flowObj in flowComponentObjs"
        :key="flowObj.id"
        :hasGap="flowObj.hasGap"
        :fullWidth="flowObj.fullWidth"
      >
        <component
          :is="flowObj.component"
          v-bind="flowObj.props"
          @reportEvent="handleReport"
          :moduleName="moduleName"
        />
      </FlowComponentContainer>
    </Main>
    <!-- 固定定位组件 -->
    <component
      v-for="positionObj in positionComponentObjs"
      :key="positionObj.id"
      :is="positionObj.component"
      v-bind="positionObj.props"
      @reportEvent="handleReport"
    />
  </div>
</template>

<script>
import { isRiskError } from '../../helper';
import Main from '../components/Main';
import PinnedBtnContainer from '../../common/PinnedBtnContainer';
import FlowComponentContainer from '@/components/templates/common/FlowComponentContainer';
import { mapActions, mapState, mapMutations } from 'vuex';
import Banner from '../components/Banner';
import { getUrlParam, parseQuery, parseURL, stringifyQuery } from '@/utils';

export default {
  components: {
    PinnedBtnContainer,
    Banner,
    FlowComponentContainer,
    Main
  },
  props: {
    actCode: String,
    moduleName: String
  },
  data() {
    return {
      disabled: false
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'login') {
      to.params.redirectObject = {
        path: '/invitee'
      };
    }
    next();
  },
  computed: {
    ...mapState('app/inviteEarnCoupon/invitee', [
      'actData',
      'tplData',
      'positionComponentObjs',
      'flowComponentObjs',
      'pinnedBtnComponentObjs'
    ]),
    dataReady() {
      return this.actData && this.tplData;
    },
    bgColorStyle() {
      if (
        this.tplData &&
        this.tplData.pageConfig &&
        this.tplData.pageConfig.backgroundColor
      ) {
        return {
          backgroundColor: this.tplData.pageConfig.backgroundColor
        };
      }
      return {};
    }
  },
  methods: {
    ...mapActions('app/inviteEarnCoupon/invitee', ['getActData']),
    ...mapMutations('app/inviteEarnCoupon/invitee', [
      'initSetActCode',
      'initSetInvitationCode'
    ]),
    redirect() {
      // 重定向至新版本
      const urlObj = parseURL(location.href);
      urlObj.pathname = '/van/8888/act3-tpl-assist';
      const oldSearchObj = parseQuery();
      const newSearchObj = {
        ...oldSearchObj,
        fromShare: '1',
        role: 'invitee',
        invitation_code: oldSearchObj.invitation_uuid
      };
      urlObj.search = `?${stringifyQuery(newSearchObj)}`;
      const url = urlObj.toString();
      location.href = url;
    },
    async initPage() {
      this.redirect();
      if (this.dataReady) {
        return;
      }
      try {
        const invitationCode = getUrlParam('invitation_uuid');
        if (!invitationCode) {
          throw { msg: '请从邀请链接进入活动' };
        }
        this.initSetInvitationCode(invitationCode);
        await this.getActData(invitationCode);
      } catch (error) {
        // 命中风控处理
        if (isRiskError(error.ret)) {
          this.$router.replace('/account_error');
          return;
        }
        // 自己的邀请码，跳回去首页
        if (this.isMyOwnTask(error.ret)) {
          setTimeout(() => {
            this.$router.replace('/');
          }, 1000);
          return;
        }
        this.$hll.toast(error && error.msg);
        return;
      }
    },
    isMyOwnTask(errorCode) {
      return Number(errorCode) === 11080;
    },
    // 埋点建议传递到最外层统一上报，方便加上 activity_id
    handleReport(data) {
      const { event, ...fields } = data;
      this.visitLog('', '', {
        ...fields,
        actEventType: event,
        activity_id: this.actCode
      });
    }
  },
  async created() {
    await this.initSetActCode(this.actCode);
    await this.initPage();
  }
};
</script>

<style lang="less" scoped>
.homeContainer {
  min-height: 100%;
}
.errorToast {
  height: 431px;
  font-size: 32px;
  color: #000;
  .fc;
}
</style>
